const API_URL = process.env.REACT_APP_API_URL;

export const getDirectionHistory = async (page = 1, limit = 20) => {
    const token = localStorage.getItem('token');
    
    return fetch(`${API_URL}/api/v1/direction-history?page=${page}&limit=${limit}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    });
};

export const getUserDirections = async () => {
    const token = localStorage.getItem('token');
    
    return fetch(`${API_URL}/api/v1/directions`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    });
};
